// extracted by mini-css-extract-plugin
export default {"root":"UpgradeDowngradeSection_root__94F6X","mainContainer":"UpgradeDowngradeSection_mainContainer__zVLOv","paymentContainer":"UpgradeDowngradeSection_paymentContainer__50Vsl"};